export default {
  countryList() {
    return {
      AF: 'Afghanistan',
      AL: 'Albanië',
      DZ: 'Algerije',
      VI: 'Amerikaanse Maagdeneilanden',
      AS: 'Amerikaans-Samoa',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarctica',
      AG: 'Antigua en Barbuda',
      AR: 'Argentinië',
      AM: 'Armenië',
      AW: 'Aruba',
      AU: 'Australië',
      AZ: 'Azerbeidjan',
      BS: "Bahama's",
      BH: 'Bahrein',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Belarus',
      BE: 'België',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BO: 'Bolivia',
      BA: 'Bosnië en Herzegovina',
      BW: 'Botswana',
      BR: 'Brazilië',
      IO: 'Brits Indische Oceaanterritorium',
      VG: 'Britse Maagdeneilanden',
      BN: 'Brunei',
      BG: 'Bulgarije',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambodja',
      CA: 'Canada',
      BQ: 'Caribisch Nederland',
      CF: 'Centraal-Afrikaanse Republiek',
      CL: 'Chili',
      CN: 'China',
      CX: 'Christmaseiland',
      CC: 'Cocoseilanden',
      CO: 'Colombia',
      KM: 'Comoren',
      CG: 'Congo-Brazzaville',
      CD: 'Congo-Kinshasa',
      CK: 'Cookeilanden',
      CR: 'Costa Rica',
      CU: 'Cuba',
      CW: 'Curaçao',
      CY: 'Cyprus',
      DK: 'Denemarken',
      DJ: 'Djibouti',
      DM: 'Dominica',
      DO: 'Dominicaanse Republiek',
      DE: 'Duitsland',
      EC: 'Ecuador',
      EG: 'Egypte',
      SV: 'El Salvador',
      GQ: 'Equatoriaal Guinea',
      ER: 'Eritrea',
      EE: 'Estland',
      SZ: 'eSwatani',
      ET: 'Ethiopië',
      FO: 'Faeröer',
      FK: 'Falklandeilanden',
      FJ: 'Fiji',
      PH: 'Filipijnen',
      FI: 'Finland',
      FR: 'Frankrijk',
      GF: 'Frans Guyana',
      TF: 'Franse Zuidelijke en Antarctische Gebieden',
      PF: 'Frans-Polynesië',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgië',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GD: 'Grenada',
      GR: 'Griekenland',
      GL: 'Groenland',
      GP: 'Guadeloupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernesey',
      GN: 'Guinee',
      GW: 'Guinee-Bissau',
      GY: 'Guyana',
      HT: 'Haïti',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Hongarij',
      IE: 'Ierland',
      IS: 'IJsland',
      IN: 'India',
      ID: 'Indonesië',
      IQ: 'Irak',
      IR: 'Iran',
      IL: 'Israël',
      IT: 'Italië',
      CI: 'Ivoorkust',
      JM: 'Jamaïca',
      JP: 'Japan',
      YE: 'Jemen',
      JE: 'Jersey',
      JO: 'Jordanië',
      KY: 'Kaaimaneilanden',
      CV: 'Kaapverdië',
      CM: 'Kameroen',
      KZ: 'Kazachstan',
      KE: 'Kenia',
      KG: 'Kiribati',
      KI: 'Kiribati',
      KW: 'Koeweït',
      XK: 'Kosovo',
      HR: 'Kroatië',
      LA: 'Laos',
      LS: 'Lesotho',
      LV: 'Letland',
      LB: 'Libanon',
      LR: 'Liberia',
      LY: 'Libië',
      LI: 'Liechtenstein',
      LT: 'Litouwen',
      LU: 'Luxemburg',
      MO: 'Macao',
      MK: 'Macedonië',
      MG: 'Madagaskar',
      MW: 'Malawi',
      MV: 'Maldiven',
      MY: 'Maleisië',
      ML: 'Mali',
      MT: 'Malta',
      IM: 'Maneiland',
      MA: 'Marokko',
      MH: 'Marshalleilanden',
      MQ: 'Martinique',
      MR: 'Mauritanië',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Mexico',
      FM: 'Micronesia',
      MD: 'Moldavië',
      MC: 'Monaco',
      MN: 'Mongolië',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MZ: 'Mozambique',
      MM: 'Myanmar',
      NA: 'Namibië',
      NR: 'Nauru',
      NL: 'Nederland',
      NP: 'Nepal',
      NI: 'Nicaragua',
      NC: 'Nieuw-Caledonië',
      NZ: 'Nieuw-Zeeland',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      MP: 'Noordelijke Marianen',
      KP: 'Noord-Korea',
      NO: 'Noorwegen',
      NF: 'Norfolk',
      UG: 'Oeganda',
      UA: 'Oekraïne',
      UZ: 'Oezbekistan',
      OM: 'Oman',
      AT: 'Oostenrijk',
      TL: 'Oost-Timor',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Palestina',
      PA: 'Panama',
      PG: 'Papoea-Nieuw-Guinea',
      PY: 'Paraguay',
      PE: 'Peru',
      PN: 'Pitcairneilanden',
      PL: 'Polen',
      PT: 'Portugal',
      PR: 'Puerto Rico',
      QA: 'Qatar',
      RE: 'Réunion',
      RO: 'Roemenië',
      RU: 'Rusland',
      RW: 'Rwanda',
      KN: 'Saint Kitts en Nevis',
      BL: 'Saint-Barthélemy',
      LC: 'Saint-Lucia',
      SX: 'Saint-Martin ',
      PM: 'Saint-Pierre en Miquelon',
      VC: 'Saint-Vincent en de Grenadines',
      SB: 'Salomoneilanden',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Sao Tome en Principe',
      SA: 'Saoedi-Arabië',
      SN: 'Senegal',
      RS: 'Servië',
      SC: 'Seychellen',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SH: 'Sint-Helena, Ascension en Tristan da Cunha',
      MF: 'Sint-Maarten',
      SI: 'Slovenië',
      SK: 'Slowakije',
      SD: 'Soedan',
      SO: 'Somalië',
      ES: 'Spanje',
      LK: 'Sri Lanka',
      SR: 'Suriname',
      SJ: 'Svalbard',
      SY: 'Syrië',
      TJ: 'Tadjikistan',
      TW: 'Taiwan',
      TZ: 'Tanzanië',
      TH: 'Thaïland',
      TG: 'Togo',
      TK: 'Tokelau-eilanden',
      TO: 'Tonga',
      TT: 'Trinidad en Tobago',
      TD: 'Tsjaad',
      CZ: 'Tsjechië',
      TN: 'Tunesië',
      TR: 'Turkije',
      TM: 'Turkmenistan',
      TC: 'Turks- en Caicoseilanden',
      TV: 'Tuvalu',
      UY: 'Uruguay',
      VU: 'Vanuatu',
      VA: 'Vaticaanstad',
      VE: 'Venezuela',
      GB: 'Verenigd Koninkrijk',
      AE: 'Verenigde Arabische Emiraten',
      US: 'Verenigde Staten',
      VN: 'Vietnam',
      WF: 'Wallis en Futuna',
      EH: 'Westelijke Sahara',
      ZM: 'Zambie',
      ZW: 'Zimbabwe',
      ZA: 'Zuid-Afrika',
      GS: 'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
      KR: 'Zuid-Korea',
      SS: 'Zuid-Soedan',
      SE: 'Zween',
      CH: 'Zwitserland',
    }
  },
  provinceList() {
    return [
      {
        name: 'Drenthe',
        value: 'DR',
      },
      {
        name: 'Flevoland',
        value: 'FL',
      },
      {
        name: 'Friesland',
        value: 'FR',
      },
      {
        name: 'Gelderland',
        value: 'GE',
      },
      {
        name: 'Groningen',
        value: 'GR',
      },
      {
        name: 'Limburg',
        value: 'LI',
      },
      {
        name: 'Noord-Brabant',
        value: 'NB',
      },
      {
        name: 'Noord-Holland',
        value: 'NH',
      },
      {
        name: 'Overijssel',
        value: 'OV',
      },
      {
        name: 'Utrecht',
        value: 'UT',
      },
      {
        name: 'Zuid-Holland',
        value: 'ZH',
      },
      {
        name: 'Zeeland',
        value: 'ZE',
      },
    ]
  },
}
